import {cloneDeep} from "lodash";
import {getString} from "Core/helpers/data";
import {SearchSalesListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {SearchSalesListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new SearchSalesListItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
	);

	return result;
}

// @note There is no output function since list is read only.